module.exports = __webpack_public_path__ + "static/media/bg.64c78745.jpg";